export function getDraftContentStats(rawJson, type) {
    try {
        const data = JSON.parse(rawJson);
        let chars = 0, words = 0, paragraphs = data.blocks.length;

        for (const block of data.blocks) {
            if (block.type === 'atomic') continue; // skip images
            const text = block.text.trim();
            chars += text.length;
            words += text ? text.split(/\s+/).filter(Boolean).length : 0;
        }
        if (type === 'words') {
            return words;
        } else if (type === 'chars') {
            return chars;
        } else if (type === 'paragraphs') {
            return paragraphs;
        } else {
            return { chars, words, paragraphs };
        }
    } catch {
        return { chars: 0, words: 0, paragraphs: 0 };
    }
}